import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonUtil } from '../../../core/Utils/common-util';
import { ToastMessageService } from '../../../core/shared-service/toast-message.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-halo-media-question',
  templateUrl: './halo-media-question.component.html',
  styleUrls: ['./halo-media-question.component.css'],
})
export class HaloMediaQuestionComponent implements OnInit, OnDestroy {
  mediaForm: FormGroup;
  rootScopeData: RootScopeDeclare;
  @Output() onClose: EventEmitter<String> = new EventEmitter();
  submitted = false;
  messageError: string;
  currentFacility: FacilityObject;
  
  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private dashboardService: DashboardService,
    private rootScopeService: RootScopeService,
    private fb: FormBuilder,
    private commonUtil: CommonUtil,
    private toastMessageService: ToastMessageService,
    private _facilityService: FacilityService
  ) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.mediaForm = this.fb.group({
      name: [
        this.rootScopeData.currentUser.displayName,
        Validators.compose([Validators.required, Validators.pattern("^[a-zA-Z -']+")]),
      ],
      email: [
        this.rootScopeData.currentUser.emailAddress,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,50}$/
          ),
        ]),
      ],
      message: ['', Validators.compose([Validators.required])],
    });
    this.messageError = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER.YOUR', [
      this.commonUtil.translateText('MESSAGE'),
    ]);

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  public alphabetMatcher(event: KeyboardEvent) {
    const allowedRegex = /[^a-zA-Z\s]/g;

    if (event.key.match(allowedRegex)) {
      event.preventDefault();
    }
  }

  get haloMediaValidator() {
    return this.mediaForm.controls;
  }
  onClickAskQuestionCancel() {
    this.onClose.emit();
  }

  submitAskQuestionForm() {
    this.submitted = true;
    if (this.mediaForm.invalid) return;

    const inputJson: object = {
      userName: this.mediaForm.value.name,
      emailAddress: this.mediaForm.value.email,
      message: this.mediaForm.value.message,
      facilityId: this.currentFacility.facilityId,
      facilityName: this.currentFacility.facilityName,
    };
    this.dashboardService.askHaloMediaQuestion(inputJson).subscribe(
      data => {
        this.onClickAskQuestionCancel();
        this.toastMessageService.emitChange(this.commonUtil.translateText('HALO.MEDIA.SUBMIT.REQUEST'));

        // this.displayToast.emit('HALO.MEDIA.SUBMIT.REQUEST');
      },
      error => {
        console.error('API failed.');
        this.onClickAskQuestionCancel();
      }
    );
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }
}
